/* eslint-disable */

const StatusIndicator = ({ title, statusColor }) => {
  return (
    <div className={"flex flex-row items-center gap-2"}>
      <div className={`${statusColor} rounded-full w-2 h-2`} />
      <div className="text-sm font-medium whitespace-nowrap">{title}</div>
    </div>
  );
};

export default StatusIndicator;
